import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__text-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "p-recommend-form__text-8 u-mt-16 u-mb-16" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "p-recommend-form__modal-help-close-2 --type-1 js-modal-close-trigger",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "ログインに戻る")
], -1)

import MailSecurityPopupView from '../mailSecurity/MailSecurityPopupView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityVefirySuccessPopupView',
  props: {
  email: {
    type: String,
    default: ''
  },
  emailNumber: {
    type: Number
  },
},
  setup(__props) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MailSecurityPopupView, null, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode("メールアドレス" + _toDisplayString(props.emailNumber) + "の認証が", 1),
        _hoisted_2,
        _createTextVNode("完了しました")
      ]),
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.email), 1),
      _hoisted_4
    ]),
    _: 1
  }))
}
}

})